<template>
	<v-row justify="center">
		<v-dialog v-if="dialog" v-model="dialog" persistent max-width="700" scrollable content-class="modal-schedule">
			<v-card>
				<v-card-title class="h6 pt-3 pb-3">List Serial {{ name }}</v-card-title>
				<v-card-text class="pb-1">
					<h4>Pilih Serial untuk menggantikan {{serial_from}}</h4>
					<v-alert v-for="(msg, index) in message" :key="index" v-model="msg.show" dense dismissible type="error" elevation="1">
						{{msg.msg}}
					</v-alert>
					<v-col class="px-0 pt-2">
						<v-text-field label="Kode Serial" clearable autofocus @keypress.enter="checkSerial" v-model="serial" ref="inputSerial" append-outer-icon="mdi-magnify" :error-messages="responseError.serial"  @focus="responseError.serial = ''" @click:append-outer="checkSerial"></v-text-field>
						<div v-show="false">Belum ada serial dipilih</div>
					</v-col>
					<v-col class="px-0">
						<v-row>
							<v-col cols="4" v-for="(item, index) in serialScan" :key="index">
								<span class="pr-1">{{item}}</span>
								<v-btn class="mr-2" fab dark x-small depressed color="pink" @click="removeSerial(index)">
									<v-icon dark>mdi-delete</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			message: [],
			serial: '',
			serialScan: [],
		}
	},
	props: {
		value: Boolean,
		edit: String,
		type: String,
		name: String,
		serial_from: String,
	},
	computed: {
		...mapState('sdo', ['response', 'responseError', 'alertMultiple']),
	},
	methods: {
		checkSerial() {
			this.saveSerial()
			this.serial = ''
		},
		removeSerial(index) {
			this.serialScan.splice(index, 1)
			this.$refs.inputSerial.$refs.input.focus()
		},
		showModal () {
			this.message = []
			this.serialScan = []
			this.serial = ''
			this.dialog = true
		},
		showMessage(msg) {
			this.message = msg
		},
		updateSerial(serial) {
			this.serialScan = serial
		},
		hideModal (){
			this.dialog = false
		},
		saveSerial() {
			if (this.serial) {
				this.$emit('saveSerial', this.serial)
			}
		}
	},
	watch: {
	},
}
</script>
<style>
.container-scanner {
	max-width: 400px;
	max-height: 300px;
}
.qrcode-stream-wrapper video {
	transform: scaleX(-1) !important;
}
</style>